<template>
    <BaseDialog :open="isConsentDialogOpen" :title="t('components.micConsent.title')" @update:open="(isOpen: boolean) => !isOpen && declineMicConsent()">
        <!-- Exact wording supplied by product/legal for the Workday rollout (ENG-1715) — do not
                 paraphrase without checking with them first. -->
        <p class="body-small text-ink-muted">{{ t("components.micConsent.body") }}</p>

        <template #footer>
            <BaseButton theme="tertiary" data-testid="mic-consent-decline" @click="declineMicConsent()">{{ t("components.micConsent.notNow") }}</BaseButton>
            <BaseButton theme="primary" data-testid="mic-consent-accept" @click="acceptMicConsent()">{{ t("components.micConsent.allow") }}</BaseButton>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import { useMicConsentDialog } from "~vue/composables/useMicConsent";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

// Mounted once at the app root (see vue.js) so no mic surface has to remember to render it, and a
// page with several mic surfaces shows one dialog rather than one per surface.
const { isConsentDialogOpen, acceptMicConsent, declineMicConsent } = useMicConsentDialog();
</script>
